import MobileSearch from '../components/search/MobileSearch';
import Scroll from '../helpers/scroll';
import Search from '../components/search/Search';
import Splide from '@splidejs/splide';
import { unitlessBreakpoints } from '../helpers';
import { disablePageScroll, enablePageScroll } from '@fluejs/noscroll';

const selectors = {
  headerNavigation: '[data-header-navigation]',
  navHamburger: '[data-nav-hamburger]',
  navClose: '[data-nav-close]',
  megaDetails: '[data-mega-details]',
  announcementBar: '[data-announcement-bar]',
  megaBackButton: '[data-submenu-back]',
  megamenuCarousel: '[data-megamenu-carousel]',
  progressBar: '[data-progress-bar]',
};

export default class MainHeader {
  constructor(section) {
    this.section = section;

    this.listener = new Scroll(this.onScroll, this.section.el);

    new Search(section);
    new MobileSearch(section);

    this.disableDesktopScroll();
    this.initMobileNavigation();
    this.initMegamenuCarousel();
  }

  onScroll = direction => {
    if (direction === 'up') {
      this.showMenu();
    } else if (direction === 'down') {
      this.hideMenu();
    }
  };

  showMenu = () => {
    this.section.el.classList.remove('-translate-y-full');
  };

  hideMenu = () => {
    this.section.el.classList.add('-translate-y-full');
  };

  disableDesktopScroll = () => {
    const megaDetails = this.section.el.querySelectorAll(selectors.megaDetails);
    megaDetails.forEach(detail => {
      detail.addEventListener('toggle', ({ newState }) => {
        if (window.innerWidth >= unitlessBreakpoints.lg) {
          if (newState === 'open') {
            disablePageScroll();
          } else {
            enablePageScroll();
          }
        }
      });
    });
  };

  initMobileNavigation = () => {
    const megaBackButtons = this.section.el.querySelectorAll(
      selectors.megaBackButton,
    );

    this.openMobileNav();
    this.closeMobileNav();

    // Set subnav heights
    megaBackButtons.forEach(button => {
      button.addEventListener('click', () => {
        const parentDetail = button.closest('details');
        parentDetail.removeAttribute('open');
      });
    });
  };

  openMobileNav = () => {
    const headerNavigation = this.section.el.querySelector(
      selectors.headerNavigation,
    );
    const navHamburger = this.section.el.querySelector(selectors.navHamburger);
    const navClose = this.section.el.querySelector(selectors.navClose);
    navHamburger.addEventListener('click', () => {
      const totalHeaderHeight = this.getHeaderHeight();
      headerNavigation.style.top = `${totalHeaderHeight - 1}px`;
      navHamburger.classList.add('hidden');
      navClose.classList.remove('hidden');
      headerNavigation.classList.remove('hidden');
      headerNavigation.classList.add('flex');
      disablePageScroll();
    });
  };

  closeMobileNav = () => {
    const headerNavigation = this.section.el.querySelector(
      selectors.headerNavigation,
    );
    const navHamburger = this.section.el.querySelector(selectors.navHamburger);
    const navClose = this.section.el.querySelector(selectors.navClose);
    navClose.addEventListener('click', () => {
      navHamburger.classList.remove('hidden');
      navClose.classList.add('hidden');
      headerNavigation.classList.add('hidden');
      headerNavigation.classList.remove('flex');
      enablePageScroll();
    });
  };

  getHeaderHeight = () => {
    const announcementBar = document.querySelector(selectors.announcementBar);
    const headerHeight = this.section.el.offsetHeight;
    let announcementBarHeight = 0;
    if (announcementBar) {
      const announcementElementHeight = announcementBar.offsetHeight;
      if (document.documentElement.scrollTop < announcementElementHeight) {
        announcementBarHeight =
          announcementBar.offsetHeight - document.documentElement.scrollTop;
      }
    }
    return headerHeight + announcementBarHeight;
  };

  initMegamenuCarousel = () => {
    const megamenuCarouselList = this.section.el.querySelectorAll(
      selectors.megamenuCarousel,
    );

    megamenuCarouselList.forEach(carousel => {
      const megamenuCarousel = new Splide(carousel, {
        perPage: 1,
        pagination: false,
        arrows: false,
        gap: 0,
        padding: {
          right: 60,
        },
        mediaQuery: 'min',
        breakpoints: {
          [unitlessBreakpoints.xs]: {
            padding: {
              right: 100,
            },
          },
          [unitlessBreakpoints.sm]: {
            destroy: true,
            padding: {
              right: 0,
            },
          },
        },
      });

      megamenuCarousel.mount();
    });
  };
}
